"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSingleCardActivityStyle;

function createSingleCardActivityStyle(_ref) {
  var bubbleMaxWidth = _ref.bubbleMaxWidth,
      bubbleMinWidth = _ref.bubbleMinWidth,
      paddingRegular = _ref.paddingRegular;
  return {
    '& > .bubble-box': {
      maxWidth: bubbleMaxWidth,
      minWidth: bubbleMinWidth
    },
    '& > .filler': {
      minWidth: paddingRegular
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TdHlsZXMvU3R5bGVTZXQvU2luZ2xlQXR0YWNobWVudEFjdGl2aXR5LnRzIl0sIm5hbWVzIjpbImNyZWF0ZVNpbmdsZUNhcmRBY3Rpdml0eVN0eWxlIiwiYnViYmxlTWF4V2lkdGgiLCJidWJibGVNaW5XaWR0aCIsInBhZGRpbmdSZWd1bGFyIiwibWF4V2lkdGgiLCJtaW5XaWR0aCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUVlLFNBQVNBLDZCQUFULE9BSVE7QUFBQSxNQUhyQkMsY0FHcUIsUUFIckJBLGNBR3FCO0FBQUEsTUFGckJDLGNBRXFCLFFBRnJCQSxjQUVxQjtBQUFBLE1BRHJCQyxjQUNxQixRQURyQkEsY0FDcUI7QUFDckIsU0FBTztBQUNMLHVCQUFtQjtBQUNqQkMsTUFBQUEsUUFBUSxFQUFFSCxjQURPO0FBRWpCSSxNQUFBQSxRQUFRLEVBQUVIO0FBRk8sS0FEZDtBQU1MLG1CQUFlO0FBQ2JHLE1BQUFBLFFBQVEsRUFBRUY7QUFERztBQU5WLEdBQVA7QUFVRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgU3RyaWN0U3R5bGVPcHRpb25zIH0gZnJvbSAnYm90ZnJhbWV3b3JrLXdlYmNoYXQtYXBpJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gY3JlYXRlU2luZ2xlQ2FyZEFjdGl2aXR5U3R5bGUoe1xuICBidWJibGVNYXhXaWR0aCxcbiAgYnViYmxlTWluV2lkdGgsXG4gIHBhZGRpbmdSZWd1bGFyXG59OiBTdHJpY3RTdHlsZU9wdGlvbnMpIHtcbiAgcmV0dXJuIHtcbiAgICAnJiA+IC5idWJibGUtYm94Jzoge1xuICAgICAgbWF4V2lkdGg6IGJ1YmJsZU1heFdpZHRoLFxuICAgICAgbWluV2lkdGg6IGJ1YmJsZU1pbldpZHRoXG4gICAgfSxcblxuICAgICcmID4gLmZpbGxlcic6IHtcbiAgICAgIG1pbldpZHRoOiBwYWRkaW5nUmVndWxhclxuICAgIH1cbiAgfTtcbn1cbiJdfQ==